import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgForm, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ClientService } from 'src/shared/services/client.service';
import { Client } from 'src/shared/models/client.model';
import { Constants } from 'src/shared/utilities/constants.util';

@Component({
  selector: 'smt-client-configuration',
  templateUrl: './client-configuration.component.html',
  styleUrls: ['./client-configuration.component.scss']
})
export class ClientConfigurationComponent implements OnInit {
  public clientConfigurationEditForm: NgForm;

  client: Client;
  selectedName: string;
  selectedInpatientNursingAccess: boolean;
  selectedNursingProceduralAncillaryAccess: boolean;
  selectedDefaultReportAccessToShiftLeaders: boolean;
  selectedTimePayCodeMappingAccess: boolean;
  selectedAncillaryPatientUOS: boolean;
  selectedTimeAndAttendance: boolean;
  selectedCostCenterLimit: number;
  selectedId: number;
  defaultReportAccessToShiftLeadersModalActive: boolean = false;
  shiftLeadersAccessconfirmationMessage: string;
  constructor(private _clientService: ClientService) {

  }
  initialLoading: boolean;
  ngOnInit() {
    this.GetClientById();
  };

  getValidation() {
    return (!this.selectedNursingProceduralAncillaryAccess && !this.selectedInpatientNursingAccess && !this.selectedDefaultReportAccessToShiftLeaders ||
      ((this.selectedInpatientNursingAccess || this.selectedNursingProceduralAncillaryAccess || this.selectedDefaultReportAccessToShiftLeaders) && !this.selectedCostCenterLimit));
  }

  async GetClientById(): Promise<void> {
    this.initialLoading = true;
    let result = this._clientService.GetClientById();
    result.then((data) => {
      if (data) {
        this.client = data;
        this.selectedId = this.client.id;
        this.selectedName = this.client.name;
        this.selectedInpatientNursingAccess = this.client.inpatientNursingAccess;
        this.selectedNursingProceduralAncillaryAccess = this.client.nursingProceduralAncillaryAccess;
        this.selectedTimePayCodeMappingAccess = this.client.timePayCodeMappingAccess;
        this.selectedDefaultReportAccessToShiftLeaders = this.client.defaultReportAccesstoShiftLeaders;
        this.selectedAncillaryPatientUOS = this.client.ancillaryPatientUOS;
        this.selectedTimeAndAttendance = this.client.timeAndAttendance;
        if (this.client.costCenterLimit != 0) {
          this.selectedCostCenterLimit = this.client.costCenterLimit;
        }
        this.initialLoading = false;
      }
    })

  }
  async saveClientConfiguration() {
    this.defaultReportAccessToShiftLeadersModalActive = false;  
    this.initialLoading = true;
    let selectedClientConfiguration = new Client;
    selectedClientConfiguration.id = this.selectedId;
    selectedClientConfiguration.inpatientNursingAccess = this.selectedInpatientNursingAccess;
    selectedClientConfiguration.nursingProceduralAncillaryAccess = this.selectedNursingProceduralAncillaryAccess;
    selectedClientConfiguration.defaultReportAccesstoShiftLeaders = this.selectedDefaultReportAccessToShiftLeaders;
    selectedClientConfiguration.timePayCodeMappingAccess = this.selectedNursingProceduralAncillaryAccess;
    selectedClientConfiguration.ancillaryPatientUOS = this.selectedAncillaryPatientUOS;
    selectedClientConfiguration.timeAndAttendance = this.selectedTimeAndAttendance;
    selectedClientConfiguration.costCenterLimit = this.selectedCostCenterLimit;
    let result = await this._clientService.UpdateClientConfiguration(selectedClientConfiguration);
    this.client = selectedClientConfiguration;
    this.selectedId = result;
    this.selectedInpatientNursingAccess = this.client.inpatientNursingAccess;
    this.selectedNursingProceduralAncillaryAccess = this.client.nursingProceduralAncillaryAccess;
    this.selectedDefaultReportAccessToShiftLeaders = this.client.defaultReportAccesstoShiftLeaders;
    this.selectedTimePayCodeMappingAccess = this.client.timePayCodeMappingAccess;
    this.selectedAncillaryPatientUOS = this.client.ancillaryPatientUOS;
    this.selectedTimeAndAttendance = this.client.timeAndAttendance;
    this.selectedCostCenterLimit = this.client.costCenterLimit;
    this.initialLoading = false;
  }
  onCancel() {
    this.initialLoading = true;
    this.resetForm();
    this.delay(1000).then(any => {
      this.initialLoading = false;
    });
  }
  resetForm() {
    if (this.client) {
      this.selectedInpatientNursingAccess = this.client.inpatientNursingAccess;
      this.selectedNursingProceduralAncillaryAccess = this.client.nursingProceduralAncillaryAccess;
      this.selectedDefaultReportAccessToShiftLeaders = this.client.defaultReportAccesstoShiftLeaders;
      this.selectedTimePayCodeMappingAccess = this.client.timePayCodeMappingAccess;
      this.selectedAncillaryPatientUOS = this.client.ancillaryPatientUOS;
      this.selectedTimeAndAttendance = this.client.timeAndAttendance;
      this.selectedCostCenterLimit = this.client.costCenterLimit;
    }
    else {
      this.selectedInpatientNursingAccess = false;
      this.selectedNursingProceduralAncillaryAccess = false;
      this.selectedTimePayCodeMappingAccess;
      this.selectedDefaultReportAccessToShiftLeaders = false;
      this.selectedAncillaryPatientUOS = false;
      this.selectedTimeAndAttendance = false;
      this.selectedCostCenterLimit = null;
    }
  }
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async OnSave() {
    if (this.client.defaultReportAccesstoShiftLeaders != this.selectedDefaultReportAccessToShiftLeaders) {
      this.showDefaultReportAccessToShiftLeadersModal();
    }
    else {
      this.saveClientConfiguration();
    }
  }

  async showDefaultReportAccessToShiftLeadersModal() {
    this.initialLoading = true;
    let shiftLeadersCount = await this._clientService.GetshiftLeadersCount(this.selectedDefaultReportAccessToShiftLeaders, this.selectedId);
    if (!isNaN(shiftLeadersCount)) {
      this.shiftLeadersAccessconfirmationMessage = this.selectedDefaultReportAccessToShiftLeaders ?
                                                    shiftLeadersCount + " users with Shift Leader permissions will now have report access.  Continue?"
                                                    : shiftLeadersCount + " users with Shift Leader permissions will no longer have report access.  Continue?";
      this.defaultReportAccessToShiftLeadersModalActive = true;
      this.initialLoading = false;
    }
  }

}
